import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Sidebar } from '../Sidebar';
import { TopBar } from '../TopBar';

import { BodyArea, ContentArea, LayoutRoot, MainArea, SidebarWrapper } from './AppLayout.styles';

export const AppLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <LayoutRoot>
      <SidebarWrapper>
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed((prev) => !prev)}
        />
      </SidebarWrapper>
      <BodyArea>
        <MainArea>
          <TopBar />
          <ContentArea>
            <Outlet />
          </ContentArea>
        </MainArea>
      </BodyArea>
    </LayoutRoot>
  );
};
